import { render, staticRenderFns } from "./FormDescription.vue?vue&type=template&id=daa9f270&"
import script from "./FormDescription.vue?vue&type=script&lang=js&"
export * from "./FormDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports